//#region Import

import { getFormattedDate, getFullDate, saveFile } from "./fileMethods";
import { addSceneLights } from "@/components/anchorage/AnchorageMode";
import { jsPDF } from "jspdf";
import {
  getTeethBox,
  getTeethZoom,
} from "@/components/occlusal/OcclusalTools.js";
import { drawBox, drawPointOnScene } from "@/components/draw/draw.js";
import {
  mandibleTransform,
  mandibleTransformInverted,
} from "@/components/controls/TeethListManager";
import { Octree } from "three/examples/jsm/math/Octree.js";
import {
  drawLine,
  drawTubeLine,
  drawText,
  drawDraggableArrow,
} from "../draw/draw";
import swal from "sweetalert";

//#endregion

//#region Fields

let pdfScene = null;
let pdfCanvas = null;
let lowerMeshes = [];
let mesh11 = null;
let mesh21 = null;
let mesh31 = null;
let mesh41 = null;
let crossedMeshes = [];

const strMime = "image/jpeg";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
//#endregion

async function generateCrossBiteReport() {
  showLoader(true);

  if (!pdfScene) {
    pdfScene = createPdfScene();

    pdfCanvas = pdfScene.renderer.domElement;
    pdfCanvas.style.position = "absolute";
    pdfCanvas.style.right = "105px";
    pdfCanvas.style.top = "40px";
    pdfCanvas.style.zIndex = "999";
    // let container = document.getElementById("views_cont");
    // container.appendChild(videoCanvas);
    // pdfScene.background = new THREE.Color("#000000");

    for (const tooth of vueApp.allTeeth) {
      let toothMesh = viewer.get_model_mesh(tooth.id);
      if (vueApp.snapToOcclusion && !tooth.isUpper)
        toothMesh.applyMatrix4(mandibleTransformInverted);

      let material = toothMesh.material.clone();
      material.opacity = 0.99;
      let clonedMesh = new THREE.Mesh(toothMesh.geometry.clone(), material);

      clonedMesh.position.copy(toothMesh.position);
      pdfScene.add(clonedMesh);

      if (!tooth.isUpper) {
        // if (vueApp.snapToOcclusion)
        //   clonedMesh.applyMatrix4(mandibleTransformInverted);
        lowerMeshes.push(clonedMesh);
      }

      if (tooth.number === 11) mesh11 = clonedMesh;
      if (tooth.number === 21) mesh21 = clonedMesh;
      if (tooth.number === 31) mesh31 = clonedMesh;
      if (tooth.number === 41) mesh41 = clonedMesh;
    }

    let teethZoom = defaultZoom;
    let teethCenter = defaultBox.center;
    let teethBox = offsetBox(getTeethBox());
    // drawBox(teethBox, 0xff0000, viewer.scene);
    // drawBox(teethBox, 0xff0000, pdfScene);

    if (teethBox && teethBox.center) {
      teethCenter = teethBox.center;
      teethZoom = getTeethZoom(teethBox, -25, pdfScene.camera);
      const validZoom = teethBox.max.z + 43;
      teethZoom = Math.max(validZoom, teethZoom);
    }

    console.log("generateCrossBiteReport teethBox", teethBox, teethZoom);

    pdfScene.camera.position.x = teethCenter.x;
    pdfScene.camera.position.y = teethCenter.y;
    pdfScene.camera.position.z = teethZoom;
    pdfScene.camera.lookAt(
      teethBox.center.x,
      teethBox.center.y,
      teethBox.center.z,
    );
    pdfScene.camera.updateProjectionMatrix();

    if (vueApp.snapToOcclusion) {
      for (const tooth of vueApp.allTeeth.filter((t) => !t.isUpper)) {
        let toothMesh = viewer.get_model_mesh(tooth.id);
        toothMesh.applyMatrix4(mandibleTransform);
      }
    }
    await delay(500);
  } else {
    for (const cmesh of crossedMeshes) {
      pdfScene.remove(cmesh);
    }
    crossedMeshes = [];
  }

  if (!mesh11 || !mesh21 || !mesh31 || !mesh41) {
    swal(
      "Some of the teeth are absent. Cross bite report could not be created.",
    );
    return hideLoader();
  }

  let crossPoint1 = getCrossPoint(mesh11, mesh21);
  let crossPoint2 = getCrossPoint(mesh31, mesh41);
  crossedMeshes.push(
    drawPointOnScene(crossPoint1, 0xff0000, 0.4, pdfScene, true),
  );
  crossedMeshes.push(
    drawPointOnScene(crossPoint2, 0xff0000, 0.4, pdfScene, true),
  );
  let opossitePoint1 = crossPoint1.clone();
  opossitePoint1.y = crossPoint2.y;
  let opossitePoint2 = crossPoint2.clone();
  opossitePoint2.y = crossPoint1.y;

  let midPoint1 = new THREE.Vector3(
    (crossPoint1.x + opossitePoint1.x) / 2,
    (crossPoint1.y + opossitePoint1.y) / 2,
    (crossPoint1.z + opossitePoint1.z) / 2,
  );
  let midPoint2 = new THREE.Vector3(
    (crossPoint2.x + opossitePoint2.x) / 2,
    (crossPoint2.y + opossitePoint2.y) / 2,
    (crossPoint2.z + opossitePoint2.z) / 2,
  );
  let distance1 = getDistance2D(midPoint1, midPoint2);
  console.log("!!! distance1", distance1);

  opossitePoint2.z = crossPoint2.z = crossPoint1.z;

  crossPoint1.y += 5;
  opossitePoint1.y -= 5;
  crossPoint2.y -= 5;
  opossitePoint2.y += 5;
  crossedMeshes.push(
    drawLine(crossPoint1, opossitePoint1, 0xff0000, pdfScene, null, true),
  );
  crossedMeshes.push(
    drawLine(crossPoint2, opossitePoint2, 0xff0000, pdfScene, null, true),
  );

  midPoint1.x -= 0.1;
  midPoint2.x += 0.1;
  midPoint2.z = midPoint1.z;
  crossedMeshes.push(
    drawTubeLine(midPoint1, midPoint2, 0x00ff00, 0.1, pdfScene, true),
  );

  let textPoint = midPoint2.clone();
  textPoint.x += 7;
  textPoint.y += 5;

  let arrowPoint1 = textPoint.clone();
  arrowPoint1.y -= 1;
  arrowPoint1.x -= 2;
  let arrowPoint2 = midPoint2.clone();
  arrowPoint2.y += 0.7;
  arrowPoint2.x += 0.7;
  crossedMeshes.push(
    drawDraggableArrow(arrowPoint1, arrowPoint2, pdfScene, 0.1, 0xff0000, true),
  );

  crossedMeshes.push(
    drawText(
      `${distance1.toFixed(1)} mm`,
      textPoint,
      vueApp.defaultFont,
      0xff0000,
      1.4,
      pdfScene,
    ),
  );

  await delay(500);

  // let container = document.getElementById("views_cont");
  // container.appendChild(pdfCanvas);
  // return hideLoader();

  const pdf = new jsPDF();
  const pdfWidth = pdf.internal.pageSize.getWidth(); // 210
  const pdfHeight = pdf.internal.pageSize.getHeight(); // 297
  pdf.setFontSize(18);
  pdf.setFont("helvetica");
  const lineHeightFactor = 0.7;
  const marginLeft = 7;

  const headerText = "Cross Bite Report";
  let headerDims = pdf.getTextDimensions(headerText);
  let headerWidth = headerDims.w;
  let headerHeight = headerDims.h;
  let headerTop = headerHeight * 2;
  const headerLeft = pdfWidth / 2 - headerWidth / 2;
  pdf.text(headerText, headerLeft, headerTop);

  let fontSize = 12;
  pdf.setFontSize(fontSize);
  let textLeft = 15;
  let textTop = headerTop + headerHeight * 2;

  let patientName = `Patient name: ${vueApp.patientFirstName} ${vueApp.patientLastName}`;
  let textDims = pdf.getTextDimensions(patientName);
  let textHeight = textDims.h;
  let lineHeight = textHeight * 2 * lineHeightFactor;
  pdf.text(patientName, textLeft, textTop);
  textTop += lineHeight;

  // let dateText = `Date: ${getFullDate()}`;
  // pdf.text(dateText, textLeft, textTop);
  // textTop += lineHeight;

  let imgData = pdfCanvas.toDataURL(strMime);

  let imgLeft = marginLeft;
  let imgTop = textTop;

  let imgWidth = pdfWidth / 2 - 10;
  let imgHeight = (imgWidth * 7) / 8;

  pdf.addImage(imgData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);

  for (const mesh of lowerMeshes) {
    mesh.applyMatrix4(mandibleTransform);
  }

  for (const cmesh of crossedMeshes) {
    pdfScene.remove(cmesh);
  }
  crossedMeshes = [];

  crossPoint1 = getCrossPoint(mesh11, mesh21);
  crossedMeshes.push(
    drawPointOnScene(crossPoint1, 0xff0000, 0.4, pdfScene, true),
  );
  crossPoint2 = getCrossPoint(mesh31, mesh41);
  crossedMeshes.push(
    drawPointOnScene(crossPoint2, 0xff0000, 0.4, pdfScene, true),
  );
  opossitePoint1 = crossPoint1.clone();
  opossitePoint1.y = crossPoint2.y;
  opossitePoint2 = crossPoint2.clone();
  opossitePoint2.y = crossPoint1.y;

  midPoint1 = new THREE.Vector3(
    (crossPoint1.x + opossitePoint1.x) / 2,
    (crossPoint1.y + opossitePoint1.y) / 2,
    (crossPoint1.z + opossitePoint1.z) / 2,
  );
  midPoint2 = new THREE.Vector3(
    (crossPoint2.x + opossitePoint2.x) / 2,
    (crossPoint2.y + opossitePoint2.y) / 2,
    (crossPoint2.z + opossitePoint2.z) / 2,
  );
  let distance2 = getDistance2D(midPoint1, midPoint2);
  console.log("!!! distance2", distance2);

  opossitePoint2.z = crossPoint2.z = crossPoint1.z;

  crossPoint1.y += 5;
  opossitePoint1.y -= 5;
  crossPoint2.y -= 5;
  opossitePoint2.y += 5;
  crossedMeshes.push(
    drawLine(crossPoint1, opossitePoint1, 0xff0000, pdfScene, null, true),
  );
  crossedMeshes.push(
    drawLine(crossPoint2, opossitePoint2, 0xff0000, pdfScene, null, true),
  );

  midPoint1.x -= 0.1;
  midPoint2.x += 0.1;
  midPoint2.z = midPoint1.z;
  crossedMeshes.push(
    drawTubeLine(midPoint1, midPoint2, 0x00ff00, 0.1, pdfScene, true),
  );
  crossedMeshes.push(
    drawTubeLine(midPoint1, midPoint2, 0x00ff00, 0.1, pdfScene, true),
  );

  textPoint = midPoint2.clone();
  textPoint.x += 7;
  textPoint.y += 5;

  arrowPoint1 = textPoint.clone();
  arrowPoint1.y -= 1;
  arrowPoint1.x -= 1;
  arrowPoint2 = midPoint2.clone();
  arrowPoint2.y += 0.7;
  arrowPoint2.x += 0.7;
  crossedMeshes.push(
    drawDraggableArrow(arrowPoint1, arrowPoint2, pdfScene, 0.1, 0xff0000, true),
  );
  crossedMeshes.push(
    drawText(
      `${distance2.toFixed(1)} mm`,
      textPoint,
      vueApp.defaultFont,
      0xff0000,
      1.4,
      pdfScene,
    ),
  );

  await delay(500);

  imgData = pdfCanvas.toDataURL(strMime);
  imgLeft = imgLeft + marginLeft + imgWidth;

  pdf.addImage(imgData, "JPEG", imgLeft, imgTop + 3, imgWidth, imgHeight);

  textTop = imgTop + imgHeight + headerHeight * 2;

  const threshold = 1.5;
  let result = "functional shift not clinically significant"; // Delta stays equal
  if (distance1 - distance2 > threshold) {
    result = "functional shift is probable"; // Delta diminishes with closure
  }
  if (distance2 - distance1 > threshold) {
    result = "functional shift is probable"; // Delta grows with closure
  }

  // Result explanation:
  let explanation = `Result explanation: ${result}`;
  pdf.setFontSize(fontSize + 1);
  pdf.text(explanation, textLeft, textTop);
  textTop += lineHeight;

  let fullName = `crossBiteReport_${getFormattedDate(true)}.pdf`;
  pdf.save(fullName);

  for (const mesh of lowerMeshes) {
    mesh.applyMatrix4(mandibleTransformInverted);
  }

  hideLoader();
}

function getDistance(point1, point2) {
  var dx = point1.x - point2.x;
  var dy = point1.y - point2.y;
  var dz = point1.z - point2.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

function getDistance2D(point1, point2) {
  if (point1 && point2) {
    var dx = point1.x - point2.x;
    var dy = point1.y - point2.y;
    return Math.sqrt(dx * dx + dy * dy);
  }
}

function getCrossPoint(mesh1, mesh2, mandibleTransform) {
  console.log("getCrossPoint", mesh1, mesh2);
  console.time("getNearestPointsWithTransforms");
  let pointsObj1 = getNearestPointsWithTransforms(
    mesh1.geometry,
    mesh2.geometry,
    mesh1.matrix,
    mesh2.matrix,
    mandibleTransform,
  );
  console.timeEnd("getNearestPointsWithTransforms");
  console.log(pointsObj1);
  let point1 = pointsObj1.pointA;
  let point2 = pointsObj1.pointB;

  let crossPoint = new THREE.Vector3(
    (point1.x + point2.x) / 2,
    (point1.y + point2.y) / 2,
    (point1.z + point2.z) / 2,
  );

  return crossPoint;
}

function getNearestPointsWithTransforms(
  geometryA,
  geometryB,
  matrixA,
  matrixB,
  mandibleTransform,
) {
  // Apply transformations if provided
  const positionsA = geometryA.attributes.position;
  const positionsB = geometryB.attributes.position;

  const verticesA = [];
  const verticesB = [];

  // Transform vertices if matrices are provided
  for (let i = 0; i < positionsA.count; i++) {
    const vertex = new THREE.Vector3();
    vertex.fromBufferAttribute(positionsA, i);
    if (matrixA) vertex.applyMatrix4(matrixA);
    if (mandibleTransform) vertex.applyMatrix4(mandibleTransform);
    verticesA.push(vertex);
  }

  for (let i = 0; i < positionsB.count; i++) {
    const vertex = new THREE.Vector3();
    vertex.fromBufferAttribute(positionsB, i);
    if (matrixB) vertex.applyMatrix4(matrixB);
    if (mandibleTransform) vertex.applyMatrix4(mandibleTransform);
    verticesB.push(vertex);
  }

  // Find nearest points
  let minDistance = Infinity;
  let nearestPointA = new THREE.Vector3();
  let nearestPointB = new THREE.Vector3();

  for (const vertexA of verticesA) {
    for (const vertexB of verticesB) {
      const distance = vertexA.distanceTo(vertexB);
      if (distance < minDistance) {
        minDistance = distance;
        nearestPointA.copy(vertexA);
        nearestPointB.copy(vertexB);
      }
    }
  }

  return {
    pointA: nearestPointA,
    pointB: nearestPointB,
    distance: minDistance,
  };
}

function getNearestPointsOptimized(geometryA, geometryB) {
  // Create bounding spheres first for rough estimation
  geometryA.computeBoundingSphere();
  geometryB.computeBoundingSphere();

  const sphereA = geometryA.boundingSphere;
  const sphereB = geometryB.boundingSphere;

  const positionsA = geometryA.attributes.position.array;
  const positionsB = geometryB.attributes.position.array;

  let minDistance = Infinity;
  let nearestPointA = new THREE.Vector3();
  let nearestPointB = new THREE.Vector3();
  let vertexA = new THREE.Vector3();
  let vertexB = new THREE.Vector3();

  // Only compare vertices that are potentially close
  for (let i = 0; i < positionsA.length; i += 3) {
    vertexA.set(positionsA[i], positionsA[i + 1], positionsA[i + 2]);

    // Quick reject if vertex is too far from the other sphere
    const distanceToSphereB =
      vertexA.distanceTo(sphereB.center) - sphereB.radius;
    if (distanceToSphereB > minDistance) continue;

    for (let j = 0; j < positionsB.length; j += 3) {
      vertexB.set(positionsB[j], positionsB[j + 1], positionsB[j + 2]);

      const distance = vertexA.distanceTo(vertexB);

      if (distance < minDistance) {
        minDistance = distance;
        nearestPointA.copy(vertexA);
        nearestPointB.copy(vertexB);
      }
    }
  }

  return {
    pointA: nearestPointA,
    pointB: nearestPointB,
    distance: minDistance,
  };
}

function getNearestPointsWithOctree(geometryA, geometryB) {
  const octree = new Octree();

  // Build octree from geometryB
  const positionsB = geometryB.attributes.position.array;
  for (let i = 0; i < positionsB.length; i += 3) {
    const vertex = new THREE.Vector3(
      positionsB[i],
      positionsB[i + 1],
      positionsB[i + 2],
    );
    octree.addVertex(vertex);
  }

  const positionsA = geometryA.attributes.position.array;
  let minDistance = Infinity;
  let nearestPointA = new THREE.Vector3();
  let nearestPointB = new THREE.Vector3();
  let vertexA = new THREE.Vector3();

  // Search nearest for each vertex in geometryA
  for (let i = 0; i < positionsA.length; i += 3) {
    vertexA.set(positionsA[i], positionsA[i + 1], positionsA[i + 2]);

    const result = octree.getClosestVertex(vertexA);

    if (result && result.distance < minDistance) {
      minDistance = result.distance;
      nearestPointA.copy(vertexA);
      nearestPointB.copy(result.vertex);
    }
  }

  return {
    pointA: nearestPointA,
    pointB: nearestPointB,
    distance: minDistance,
  };
}

function createPdfScene() {
  let width = 800;
  let height = 700;

  const scene = new THREE.Scene();
  scene.background = new THREE.Color("#FFFFFF"); //000000 FFFFFF

  const renderer = new THREE.WebGLRenderer();
  renderer.setSize(width, height);
  scene.renderer = renderer;

  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1e4);
  scene.add(camera);
  scene.camera = camera;
  scene.camera.aspect = width / height;
  scene.camera.updateProjectionMatrix();
  //   scene.add(new THREE.AxesHelper(80));
  // const controls = new THREE.AstroControls(camera, renderer.domElement);

  addSceneLights(scene, camera);

  function animate() {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
    // controls.update();
  }
  animate();
  return scene;
}

function showLoader(isGray) {
  $id("loader").style.display = "block";
  $id("loader").style.opacity = "0.7";
  if (isGray) {
    $id("loader").style.background =
      !vueApp.isWhite && isGray ? "gray" : "white";
  }
  $("#loaderText").html(`Generating cross bite report...`);
  $("#loaderText2").html(``);
  $("#loaderText3").html(``);
}

function hideLoader() {
  $id("loader").style.display = "none";
}

export { generateCrossBiteReport };
